import { connect } from 'react-redux';
import { ActionCreators as UndoActionCreators } from 'redux-undo';

import DefaultHeader from '../../../../components/DefaultHeader';

const mapStateToProps = ({ undoableEnvironments: { past, future, readOnly } }) => {
  return {
    canRedo: future.length > 0,
    canUndo: past.length > 0,
    showSearch: true,
    showUndoRedo: !readOnly,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onRedo: () => dispatch(UndoActionCreators.redo()),
    onUndo: () => dispatch(UndoActionCreators.undo()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DefaultHeader);
